
define(
	'MHI.BasicEnhancements.MyAccountEntryPoints'
,   [
		
	]
,   function (
		
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			

		}
	};
});
